import { Router, Switch, Route } from 'react-router-dom';
import { HeaderContainer, ContentContainer } from '.';
import { TeamDetailInfo } from './TeamDetailInfo';
import { MATCH_LINK, REAL_MADRID, COMPETITION_LINK, SELECTED_COUNTRIES } from '../constants';
import CompetitionContent from './Competitions';
import Header from './Header';
import Home from './Home';
import Link from './Link';
import Map from './Map';
import MatchGallery from './MatchGallery';
import RMMatchGallery from './RMMatchGallery';
import SideTree from './SideTree';
import TeamGalleryRoute from './TeamGalleryRoute';
import { createBrowserHistory } from 'history';
import { IStore } from '../../interfaces';
import { useSelector } from 'react-redux';
// import ReactGA from 'react-ga';

// let _ignoreGA = false;
export const history = createBrowserHistory();
// ReactGA.initialize('UA-180270300-1');
// history.listen((locationListener: Update) => {
// 	if (process.env.NODE_ENV !== 'development' && !_ignoreGA) {
// 		ReactGA.pageview(locationListener.location.pathname + locationListener.location.search);
// 	}
// });
export default function AppRouter({
	shouldRenderTreeMap,
	isMobileViewActive,
}: {
	shouldRenderTreeMap: boolean;
	isMobileViewActive: boolean;
}) {

	const initialized = useSelector(
		(completeState: IStore): boolean => {
			return !!completeState?.initialized;
		});

	// useEffect(() => {
	// 	const parsedQuery = queryString.parse(window.location.search);
	// 	for (const key of Object.keys(parsedQuery)) {
	// 		if (key.toLowerCase() === 'ignorega') {
	// 			_ignoreGA = true;
	// 		}
	// 	}
	// }, []);

	return (
		<Router history={history}>
			<HeaderContainer>
				<Header/>
			</HeaderContainer>
			<ContentContainer>
				<TeamDetailInfo/>
				{initialized &&
					<Switch>
						<Route path={'/links'}>
							{shouldRenderTreeMap ? <SideTree/> : null}
							<Link/>
						</Route>
						<Route path={'/map'}>
							{shouldRenderTreeMap && isMobileViewActive ? <SideTree/> : null}
							<Map/>
						</Route>
						<Route path={`/${MATCH_LINK}`}>
							{shouldRenderTreeMap ? <SideTree/> : null}
							<MatchGallery/>
						</Route>
						<Route path={`/${REAL_MADRID}`}>
							{shouldRenderTreeMap ? <SideTree/> : null}
							<RMMatchGallery/>
						</Route>
						<Route path={`/${COMPETITION_LINK}`}>
							{shouldRenderTreeMap ? <SideTree/> : null}
							<CompetitionContent/>
						</Route>
						<Route path={'/:countryEnglishName'}>
							{shouldRenderTreeMap ? <SideTree/> : null}
							<TeamGalleryRoute/>
						</Route>
						<Route path={`/${SELECTED_COUNTRIES}`}>
							{shouldRenderTreeMap ? <SideTree/> : null}
							<TeamGalleryRoute/>
						</Route>
						<Route path={'/'}>
							{shouldRenderTreeMap ? <SideTree/> : null}
							<Home/>
						</Route>
					</Switch>
				}
			</ContentContainer>
		</Router>
	);
}

// export class AppRouter extends PureComponent<{ shouldRenderTreeMap: boolean; isMobileViewActive: boolean; }, {}> {
// 	public render() {
// 		return (
// 			<Router history={history}>
// 				<HeaderContainer>
// 					<Header />
// 				</HeaderContainer>
// 				<ContentContainer>
// 					<TeamDetailInfo />
// 					<Switch>
// 						<Route path={'/exchange'}>
// 							{this.props.shouldRenderTreeMap ? <SideTree /> : null}
// 							<Exchange />
// 						</Route>
// 						<Route path={'/links'}>
// 							{this.props.shouldRenderTreeMap ? <SideTree /> : null}
// 							<Link />
// 						</Route>
// 						<Route path={'/map'}>
// 							{this.props.shouldRenderTreeMap && this.props.isMobileViewActive ? <SideTree /> : null}
// 							<Map />
// 						</Route>
// 						<Route path={`/${MATCH_LINK}`}>
// 							{this.props.shouldRenderTreeMap ? <SideTree /> : null}
// 							<MatchGallery />
// 						</Route>
// 						<Route path={`/${REAL_MADRID}`}>
// 							{this.props.shouldRenderTreeMap ? <SideTree /> : null}
// 							<RMMatchGallery />
// 						</Route>
// 						<Route path={`/${COMPETITION_LINK}`}>
// 							{this.props.shouldRenderTreeMap ? <SideTree /> : null}
// 							<CompetitionContent />
// 						</Route>
// 						<Route path={'/:countryEnglishName'}>
// 							{this.props.shouldRenderTreeMap ? <SideTree /> : null}
// 							<TeamGalleryRoute />
// 						</Route>
// 						<Route path={`/${SELECTED_COUNTRIES}`}>
// 							{this.props.shouldRenderTreeMap ? <SideTree /> : null}
// 							<TeamGalleryRoute />
// 						</Route>
// 						<Route path={'/'}>
// 							{this.props.shouldRenderTreeMap ? <SideTree /> : null}
// 							<Home />
// 						</Route>
// 					</Switch>
// 				</ContentContainer>
// 			</Router>
// 		);
// 	}
// }
